import { Component, OnInit, ViewChild } from '@angular/core';
import { saveAs } from 'file-saver';
import moment from 'moment';
import { MenuItem } from 'primeng/api';
import { ContextMenu } from 'primeng/contextmenu';
import { MasterRequest } from 'src/app/person-on-board/model/masterrequest.model';
import { UserPermissionParameters } from 'src/app/shared/models/user.model';
import { NotificationsService } from 'src/app/shared/services/notification.service';
import { FileUtility } from 'src/app/shared/utility/file.utility';
import { Login } from '../../../../app/observation/model/login.model';
import { MasterscreenService } from '../../../masterscreen/services/masterscreen.service';
import { SearchText } from '../../../observation/model/searchTexts.model';
import { ObservationService } from '../../../observation/services/observation.service';
import { BaseService } from '../../../shared/services/base.service';
import { CommonService } from '../../../shared/services/common.service';
import { TNCFilter } from '../../model/TNCFilter.model';
import { TNCGetRecords } from '../../model/TNCGetRecords.model';
import { TNCPermission } from '../../model/TNCPermission.model';
import { TncConstantsService } from '../../services/tnc-constants.service';
import { TrainingAndCompetencyService } from '../../services/training-and-competency.service';

@Component({
  selector: 'ara-tnc-dashboard',
  templateUrl: './tnc-dashboard.component.html',
  styleUrls: ['./tnc-dashboard.component.css']
})
export class TncDashboardComponent implements OnInit {
  @ViewChild('cm') contextMenu: ContextMenu;
  routesFlag: { routeName: string; routeURL: string; isClickable: boolean; }[];
  reportRoutes: { routeName: string; routeURL: string; isClickable: boolean; }[];
  tncRecords: TNCGetRecords[] = [];
  rowCount: number;
  pageSize: number = 1;
  itemPerPage: number = 50;
  hideFilter: boolean;
  hideSort: boolean;
  searchText: string = "";
  isTnCChecked: boolean = true;
  searchModified: boolean;
  locations: any[];
  loggedInUserJSON: any;
  tncFilter: TNCFilter;
  unitList: any[];
  selectedUnit: number[] = [];
  locationList: any[];
  locationDetails: any;
  selectedLocation: number[] = [];
  tncFromDate: Date = null;
  tncToDate: Date = null;
  selectedStatus: number[] = [];
  selectedUserId: number[] = [];
  selectedTraining: number[] = [];
  status: any[] = [];
  statusList: any[];
  departmentList: any[];
  usersList: any[];
  allUsers: any;
  searchTexts: SearchText;
  allUsersData: any[] = [];
  TrainingTitles: any[] = [];
  allUnit: any[] = [];
  currentFileUrl: string;
  display: boolean = false;
  PDFCourseId: number;
  PreviewUrl: string = "";
  isDownload: boolean = false;
  exportData: any;
  columnList: { key: string; value: string; }[];
  reporties: number[] = [];
  userPermissions: UserPermissionParameters = new UserPermissionParameters();
  tncPermissions: TNCPermission = new TNCPermission();
  tncRecordList: any;
  tncRequestForDataResponse: MasterRequest[] = [];
  isTnCRequestsChecked: boolean;
  independentPermissions: any;
  FileName: string = "";
  contextItems: MenuItem[] = [];
  row: HTMLElement;
  selectedCourse : number;
  disableExport: boolean = false;

  constructor(private baseService: BaseService,
    private masterscreenService: MasterscreenService,
    private TnCService: TrainingAndCompetencyService,
    private observationService: ObservationService,
    private commonService: CommonService, private notificationsService: NotificationsService
  ) {
    this.routesFlag = TncConstantsService.TNCNavigation.InnerRoutes;
    this.reportRoutes = TncConstantsService.TNCNavigation.ReportRoutes;
    this.tncRecords = [];
    this.locations = [];
  }

  ngOnInit(): void {
    this.contextItems = [
      {
        label: 'Open In New Tab',
        icon: 'fa-external-link-square',
        command: e => this.openTNCCourse()
      }
    ];
    const loggedInUser = this.baseService.getItemFromSession("loggedInUser");
    this.independentPermissions = JSON.parse(
      this.baseService.getItemFromSession("UserIndependentPermissions")
    );
    this.loggedInUserJSON = JSON.parse(loggedInUser);
    this.searchTexts = new SearchText();
    this.getUnits();
    this.searchModified = false;
    this.tncFilter = new TNCFilter();
    this.getParticularInfo();
    let routes = JSON.stringify(TncConstantsService.TNCNavigation.Routes);
    this.routesFlag = JSON.parse(routes);
    this.tncPermissions = JSON.parse(this.baseService.getItemFromSession('UserIndependentPermissions'));
    if (!this.tncPermissions.TNC_Add && !this.tncPermissions.TNC_Add_Unit && !this.tncPermissions.TNC_Admin && !this.tncPermissions.TNC_Admin_Unit) {
      for (let index = 0; index < this.routesFlag.length; index++) {
        if (this.routesFlag[index].routeName === 'Assign Training/Certification') {
          this.routesFlag.splice(index, 1);
        }
      }
    }
  }

  showContextMenu(tncRecord:any) {
    this.selectedCourse = tncRecord.CourseId;
    this.selectedUnit = tncRecord.UnitId;
  }
  openTNCCourse() {
    window.open(
      "/tnc/assign-training/" + this.selectedCourse+';unitId=' + this.selectedUnit,"_blank"
    );
    this.contextMenu.hide();
  }

  getUnits() {
    const apiRequestUnit = {
      Model: {
        ModuleId: 0,
        UserId: this.loggedInUserJSON.UserId,
        IsActive : 0
      },
    };
    this.masterscreenService.getUnits(
      apiRequestUnit,
      this.callbackMethodForUnitDetails.bind(this)
    );
  }
  callbackMethodForUnitDetails(response) {
    if (response.Success) {
      this.allUnit = response.Result;
      this.unitList = [];
      this.allUnit.forEach((unit) => {
        this.unitList.push({
          label: unit.UnitName,
          value: unit.UnitId,
          checked: true
        });
        this.selectedUnit.push(unit.UnitId)
      });
    }
    this.getAllUsers();
  }

  getLocations() {
    const login = new Login();
    login.CompanyId = 0;
    const apiRequest = {
      Model: login
    };
    this.observationService.getLocationData(apiRequest, this.callbackMethodForGetLocationData.bind(this));
  }
  callbackMethodForGetLocationData(response) {
    this.locationList = [];
    if (response) {
      if (response.Success) {
        this.locationDetails = response.Result;

      }
    } else {
      this.locationDetails = JSON.parse(this.baseService.getItemFromSession("allLocations"));
    }
    this.locationDetails.forEach((location) => {
      location['checked'] = true;
      this.locationList.push(
        {
          'label': location.LocationName,
          'value': location.LocationId,
          'checked': true
        }
      );
      this.selectedLocation.push(location.LocationId);
    });
    this.getTNCRequestData();
  }

  getTNCRequestData() {
    this.baseService.showRootLoader = true;
    if (!this.rowCount) {
      this.rowCount = this.itemPerPage * 2;
    }
    this.tncFilter.PageSize = this.itemPerPage;
    this.tncFilter.SearchText = this.searchText;
    this.tncFilter.FromDate =
      this.tncFromDate !== null
        ? new Date(this.tncFromDate.setHours(0, 0, 0, 0))
        : this.tncFromDate;
    this.tncFilter.ToDate =
      this.tncToDate !== null
        ? new Date(this.tncToDate.setHours(23, 59, 59, 0))
        : this.tncToDate;
    this.tncFilter.Units = this.selectedUnit;
    this.tncFilter.StatusId = this.selectedStatus;
    this.tncFilter.TrainingId = this.selectedTraining;
    if (!this.tncFilter.OrderdByColoumName) {
      this.tncFilter.OrderdByColoumName = "CourseId";
    }
    if (!this.tncFilter.OrderdBy) {
      this.tncFilter.OrderdBy = "DESC"
    }
    this.tncFilter.UserId = this.loggedInUserJSON.UserId;
    this.tncFilter.CurrentPage = this.pageSize;
    if (this.pageSize === 1) {
      this.tncFilter.PageIndex = 0;
    } else {
      this.tncFilter.PageIndex = ((this.pageSize * this.itemPerPage) - this.itemPerPage);
      this.rowCount = ((this.pageSize + 1) * this.itemPerPage);
    }
    this.tncFilter.SelectAll = this.isTnCChecked;
    this.tncFilter.Users = this.selectedUserId;

    const filter = JSON.parse(this.baseService.getFilterData('tncFilter'));
    if (!this.searchModified && filter) {
      this.tncFilter = filter;
      this.tncFromDate = filter.FromDate === null ? filter.FromDate : new Date(filter.FromDate);
      this.tncToDate = filter.ToDate === null ? filter.ToDate : new Date(filter.ToDate);
      this.selectedUnit = filter.Units;
      this.isTnCChecked = filter.SelectAll;
      this.unitList.forEach(element => {
        element.checked = this.selectedUnit.includes(element) ? true : false;
      });
      this.selectedStatus = filter.StatusId;
      this.status.forEach(element => {
        element.checked = this.selectedStatus.includes(element) ? true : false;
      });
      this.allUsersData.forEach(element => {
        element.checked = this.selectedUserId.includes(element) ? true : false;
      });
      this.selectedTraining = filter.TrainingId;
      this.TrainingTitles.forEach(element => {
        element.checked = this.selectedTraining.includes(element) ? true : false;
      });
      this.selectedUserId = filter.Users;
    }
    else {
      this.baseService.setFilterData('tncFilter', JSON.stringify(this.tncFilter));
    }
    this.tncFilter.UserId = this.loggedInUserJSON.UserId;
    const apiRequest = {
      Model: this.tncFilter,
    };
    this.TnCService.getTNCRequests(
      apiRequest,
      this.callbackMethodForGetTNCRequestsData.bind(this)
    );
  }
  getCurrentDOMElementId(id) {
    this.TnCService.setcurrentCourseRequestId(id);
    let courses = this.TnCService.getAllTnCIds();
    if (!courses.filter(obs => {
      if (obs.CourseId === id) {
        return obs;
      }
    })) {
      this.tncRecords.forEach(element => {
        if (element.CourseId === id) {
          courses.push(element);
          return;
        }
      });
      
      this.TnCService.setAllTnCRequestIds(courses);
    }
  }

  callbackMethodForGetTNCRequestsData(response) {
    if (response.Success) {
      this.tncRecords = [];
       //BOC Pritesh
       if(response.Result.length > 0)
       {
       response.Result.forEach((element,index) => {
         if(element.StatusName ==='Draft' && element.CreatedBy !== this.loggedInUserJSON.UserId)  
         {
           response.Result.splice(index,1);
         }
       });
       }
        //EOC Pritesh
      this.tncRecordList = response.Result;
      if (this.tncRecordList) {
        this.tncRecordList.forEach((record) => {
          this.tncRecords.push({
            CourseId: record.CourseId,
            UnitId: this.allUnit.find(u => u.UnitId == record.UnitId) ?
              this.allUnit.find(u => u.UnitId == record.UnitId).UnitId : 0,
            UnitName: this.allUnit.find(u => u.UnitId == record.UnitId) ?
              this.allUnit.find(u => u.UnitId == record.UnitId).UnitName : "",
            UserId: record.UserId,
            NameOfEmployee: this.allUsers.find(u => u.UserId == record.UserId).FullName,
            Designation: this.allUsers.find(u => u.UserId == record.UserId).Designation,
            ReportingTo: this.allUsers.find(u => u.UserId == (this.allUsers.find(u => u.UserId == record.UserId).ReportingTo)) ?
            this.allUsers.find(u => u.UserId == (this.allUsers.find(u => u.UserId == record.UserId).ReportingTo)).FullName : "",
            ParticularName: record.ParticularName,
            DurationFrom: record.DurationFrom,
            DurationTo: record.DurationTo,
            StatusName: record.StatusName,
            Validity: record.Validity,
            ExpiryDate: record.ExpiryDate ? moment(moment.utc(record.ExpiryDate).local()).toDate() : null,
            Certificate: record.Certificate,
            CertificateId: 0,
            Checked: true,
          });
        });
      }
      if (this.tncRecords.length < this.itemPerPage) {
        this.rowCount = this.rowCount - this.itemPerPage;
      }

      if (this.tncFilter.SelectAll && !this.searchModified) {
        this.selectAllTnCRequests(this.tncFilter.SelectAll);
      } else if (this.searchModified) {
        this.tncFilter.SelectAll = true;
        this.isTnCChecked = true;
        this.TnCService.setAllTnCRequestIds([]);
        this.selectAllTnCRequests(this.tncFilter.SelectAll);
      } else {
        if (this.TnCService.getAllTnCRequestIds()) {
          this.tncRecords.forEach(record => {
            this.TnCService.getAllTnCRequestIds().forEach(element => {
              if (element.CourseId === record.CourseId) {
                record.Checked = true;
                return;
              }
            });
          });
        }
      }
    }
    this.baseService.showRootLoader = false;
  }

  selectAllTnCRequests(checked) {
    let selectedTnCRequests: StoredTnCRequests[] = [];
    selectedTnCRequests = [];
    this.tncRecords.forEach((element) => {
      if (checked) {
        element.Checked = true;
        let tncElem: StoredTnCRequests = new StoredTnCRequests();
        tncElem.CourseId = element.CourseId;
       // selectedTnCRequests = this.TnCService.getAllTnCRequestIds();
        // if (!selectedTnCRequests) {
        //   selectedTnCRequests = [];
        // }
        
        selectedTnCRequests.push(tncElem);
        
        this.TnCService.setAllTnCRequestIds(selectedTnCRequests);
      } else {
        element.Checked = false;
        this.TnCService.setAllTnCRequestIds([]);
      }
    });
    this.tncFilter.SelectAll = this.isTnCChecked;
    this.baseService.setFilterData(
      "tncFilter",
      JSON.stringify(this.tncFilter)
    );
  }

  onClickedOutside() {
    this.hideFilter = false;
    if (this.hideFilter == false && this.searchModified == true) {
      this.hideFilter = this.searchModified;
      this.searchModified = false;
    }
    this.hideSort = false;
  }

  onTabOpen() {
    this.hideFilter = true;
    this.hideSort = true;
  }

  getAllUsers(){
    this.masterscreenService.getUserDetails(
      null,
      this.callbackMethodForGetUserDetails.bind(this)
    );
  }
  callbackMethodForGetUserDetails(response) {
    if (response && response.Result) {
    this.allUsers = response.Result;
    this.allUsersData = [];
      this.allUsers.forEach(s => {
        this.allUsersData.push({
          'label': s.FullName,
          'value': s.UserId,
          'checked': true
        });
        this.selectedUserId.push(s.UserId);
      }
      );
      this.setTnCStatus();
    }
  }

  setTnCStatus() {
    const apiRequest = {
      Model: {}
    };
    this.TnCService.getTrainingStatus(apiRequest, this.callbackMethodForGetTrainingStatus.bind(this));
  }
  callbackMethodForGetTrainingStatus(response) {
    this.status = [];
    if (response) {
      if (response.Success) {
        response.Result.forEach(element => {
          if ((((this.independentPermissions.SUPER_Admin && element.StatusName == 'Cancelled') || (element.StatusName != 'Cancelled' && element.StatusName != 'Deleted')) ||
            ((this.independentPermissions.SUPER_Admin && element.StatusName == 'Deleted') || (element.StatusName != 'Deleted' && element.StatusName != 'Cancelled')))) {
            this.status.push(
              {
                'value': element.StatusId,
                'label': element.StatusName,
                'checked': true
              });
            this.selectedStatus.push(element.StatusId);
          }
        });
      }
    }
    this.getLocations();
  }

  resetFilter() {
    this.selectedUnit = [];
    this.unitList.forEach(element => {
      this.selectedUnit.push(element.value)
    });
    this.selectedStatus = [];
    this.status.forEach(element => {
      this.selectedStatus.push(element.value)
    });
    this.selectedUserId = [];
    this.allUsersData.forEach(element => {
      this.selectedUserId.push(element.value)
    });
    this.selectedTraining = [];
    this.TrainingTitles.forEach(element => {
      this.selectedTraining.push(element.value)
    });
    this.tncToDate = null;
    this.tncFromDate = null;
    this.searchModified = true;
    this.getTNCRequestData();
    this.onClickedOutside();
  }

  doneFilter() {
    this.searchModified = true;
    this.getTNCRequestData();
    this.hideFilter = false;
  }

  ascCourseId() {
    this.tncFilter.OrderdByColoumName = "CourseId";
    this.tncFilter.OrderdBy = "ASC";
    this.searchModified = true;
    this.getTNCRequestData();
  }
  descCourseId() {
    this.tncFilter.OrderdByColoumName = "CourseId";
    this.tncFilter.OrderdBy = "DESC";
    this.searchModified = true;
    this.getTNCRequestData();
  }
  ascPlannedDate() {
    this.tncFilter.OrderdByColoumName = "CourseDurationFrom";
    this.tncFilter.OrderdBy = "ASC";
    this.searchModified = true;
    this.getTNCRequestData();
  }
  descPlannedDate() {
    this.tncFilter.OrderdByColoumName = "CourseDurationFrom";
    this.tncFilter.OrderdBy = "DESC";
    this.searchModified = true;
    this.getTNCRequestData();
  }
  ascName() {
    this.tncFilter.OrderdByColoumName = "Name";
    this.tncFilter.OrderdBy = "ASC";
    this.searchModified = true;
    this.getTNCRequestData();
  }
  descName() {
    this.tncFilter.OrderdByColoumName = "Name";
    this.tncFilter.OrderdBy = "DESC";
    this.searchModified = true;
    this.getTNCRequestData();
  }
  exportToExcel() {
    this.disableExport = true;
    this.notificationsService.toastNotify('info', 'Information Message', 'Downloading is in progress!');
    const filter = JSON.parse(this.baseService.getFilterData('tncFilter'));
    filter.SourceIds = [];
    this.TnCService.getAllTnCRequestIds().forEach(element => {
      filter.SourceIds.push(element.CourseId);
    });
    const apiRequest = {
      Model: filter
    };
    // Call dummy method to post data
    this.TnCService.exportToExcelTnCCourses(apiRequest, this.callbackMethodForexportToExcelTnCCoursesData.bind(this));
  }
  callbackMethodForexportToExcelTnCCoursesData(response) {
    if(response.Success){
      this.exportData = response.Result;
      this.columnList = [
        { key: "TnCNumber", value: "Course Number" },
        { key: "UserName", value: "Name Of Employee" },
        { key: "UnitName", value: "Unit" },
        { key: "Designation", value: "Designation" },
        { key: "ReportingTo", value: "Reporting To" },
        { key: "TrainingTitle", value: "Training Title" },
        { key: "FromDate", value: "Duration From" },
        { key: "ToDate", value: "Duration To" },
        { key: "Status", value: "Training Status" },
        { key: "ExpiryDate", value: "Expiry/Validity" },
        { key: "Certificate", value: "Certificate" },
      ];
      const parsedResponse: any = FileUtility.convertToCSV(this.exportData, this.columnList);
      FileUtility.downloadCSV(parsedResponse, 'TnCCoursesReport.csv');
    }
    else{
      this.notificationsService.toastNotify(
        "error",
        "Error Message",
        "Something Went Wrong."
      );
    }
    this.disableExport = false;
  }


  selectTncRequests(tncRecord, event) {
    let tncRecords = this.TnCService.getAllTnCRequestIds();
    if (event.target.checked) {
      tncRecords.push({ 'CourseId': tncRecord.CourseId, 'UnitId': tncRecord.UnitId });
      if (tncRecords.length === this.tncRequestForDataResponse.length) {
        this.isTnCChecked = true;
      }
    } else {
      this.isTnCChecked = false;
      this.tncFilter.SelectAll = this.isTnCChecked;
      for (let index = 0; index < tncRecords.length; index++) {
        const element = tncRecords[index];
        if (tncRecord.permitId === element.PermitId) {
          tncRecords.splice(index, 1);
          break;
        }
      }
    }
    
    this.TnCService.setAllTnCRequestIds(tncRecords);
    this.baseService.setFilterData('tncFilter', JSON.stringify(this.tncFilter));
  }


  downloadZIP() {
    this.disableExport = true;
    this.notificationsService.toastNotify('info', 'Information Message', 'Downloading is in progress!');
    const tncRequestIds = [];
    this.TnCService.getAllTnCRequestIds().forEach(element => {
      tncRequestIds.push({
        ProcessName: 'TNCRequest',
        SourceId: element.CourseId,
        UserId: this.loggedInUserJSON.UserId
      });
    });
    if (tncRequestIds.length > 0) {
      const apiRequest = {
        Model: {
          SourceIds: tncRequestIds
        }
      }
      this.TnCService.downloadZIP(apiRequest, this.callbackMethodForDownloadZIP.bind(this));
    }
  }

  callbackMethodForDownloadZIP(response) {
    if (response) {
      //Here assign the Byte array returned from API to data variable
      var fileDownLoadName = "zip_tnc_requests.zip"; //Here we can assign name of the document
      FileUtility.downloadPDF(response, fileDownLoadName);
    }
    else{
      this.notificationsService.toastNotify(
        "error",
        "Error Message",
        "Something Went Wrong."
      );
    }
    this.disableExport = false;
  }

  searchData() {
    this.tncFilter.SearchText = this.searchText;
    this.searchModified = true;
    this.getTNCRequestData();
  }

  clearSearch() {
    this.searchText = "";
    this.searchModified = true;
    this.getTNCRequestData();
  }
  getServerData(event) {
    this.TnCService.setcurrentTNCPageIndex(event);
    if (event === 1) {
      this.tncFilter.PageIndex = 0;
    } else {
      this.tncFilter.PageIndex = ((event * this.itemPerPage) - this.itemPerPage);
      this.rowCount = ((event + 1) * this.itemPerPage);
    }
    this.tncFilter.CurrentPage = event;
    this.pageSize = event;
    this.searchModified = true;
    this.getTNCRequestData();
  }

  selectFile(fileUrl) {
    this.currentFileUrl = fileUrl;
  }

  showDialog(CourseId) {
    if (this.tncRecords.find((x) => x.CourseId == CourseId).Certificate.length) {
      this.PreviewUrl = this.tncRecords.find((x) => x.CourseId == CourseId).Certificate[0].SourceUrl;
      this.FileName = this.tncRecords.find((x) => x.CourseId == CourseId).Certificate[0].Name;
      this.display = true;
    }
  }

  downloadFile() {
    saveAs(this.PreviewUrl, this.FileName);
  }

  downloadPDF(CourseId) {
    this.notificationsService.toastNotify(
      "info",
      "Information Message",
      "Download is in Progress!"
    );
    const apiRequest = {
      Model: {
        ProcessName: "TNCRequest",
        SourceId: CourseId,
        UserId: this.loggedInUserJSON.UserId
      }
    };
    this.TnCService.downloadPDF(apiRequest, this.callbackMethodForDownloadPDF.bind(this));
  }

  callbackMethodForDownloadPDF(response) {
    if (response) {
      //Here assign the Byte array returned from API to data variable
      var fileDownLoadName = "pdf_tnc.pdf"; //Here we can assign name of the document
      FileUtility.downloadPDF(response, fileDownLoadName);

    }
  }

  getParticularInfo() {
    const apiRequest = {
      Model: {
        PriorityId: 0,
        SpecificationId: 0,
        GetActiveParticulars: false
      },
    };
    this.TnCService.getTnCParticulars(
      apiRequest,
      this.callbackMethodForGetAllParticularName.bind(this)
    );
  }

  callbackMethodForGetAllParticularName(response) {
    for (let item of response.Result) {
      this.TrainingTitles.push({
        value: item.ParticularId, label: item.ParticularName
      });
    }
    this.TrainingTitles.forEach(x => this.selectedTraining.push(x.value));
  };

  exportToTrainingMatrixExcel() {
    this.disableExport = true;
    this.notificationsService.toastNotify('info', 'Information Message', 'Downloading is in progress!');
    const filter = JSON.parse(this.baseService.getFilterData('tncFilter'));
    filter.SourceIds = [];
    this.TnCService.getAllTnCRequestIds().forEach(element => {
      filter.SourceIds.push(element.CourseId);
    });
    const apiRequest = {
      Model: filter
    };
    this.TnCService.exportToTrainingMatrixExcel(apiRequest, this.callbackMethodForExportToTrainingMatrixExcel.bind(this));
  }
  callbackMethodForExportToTrainingMatrixExcel(response) {
    if(response){
      
      var fileDownLoadName = "tnc_Matrix_Excel_export_" + new Date().toDateString().replace(':', '_') + ".xlsx"; //Here we can assign name of the document
      FileUtility.downloadPDF(response, fileDownLoadName);
    }
    else{
      this.notificationsService.toastNotify(
        "error",
        "Error Message",
        "Something Went Wrong."
      );
    }
    this.disableExport = false;
  }

  getOutput(output) {
    if (output) {
      this.ngOnInit();
    } else {
      this.notificationsService.toastNotify('error', 'Error Message', 'Record is in use!');
    }
  }

}
export class StoredTnCRequests {
  CourseId: number;
  UnitId: number;
}
